import { render, staticRenderFns } from "./IpFilters.vue?vue&type=template&id=5b366c48&scoped=true&"
import script from "./IpFilters.vue?vue&type=script&lang=js&"
export * from "./IpFilters.vue?vue&type=script&lang=js&"
import style0 from "./IpFilters.vue?vue&type=style&index=0&id=5b366c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b366c48",
  null
  
)

export default component.exports